import { faRightToBracket, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { useEffect, useState } from 'react';
import Button from '../../Shared/Form/Button';
import Form from '../../Shared/Form/Form';
import Input from '../../Shared/Form/Input';
import Title from '../../Shared/Title';
import SidePanelWrapper from '../SidePanelWrapper';
import { useLoginMutation } from "../../../Redux/Api/Auth";
import StatusPopups from '../../Shared/Form/StatusPopups';
import { Strings } from '../../../Strings/nl';
import { useAppDispatch, useAppSelector } from '../../../Redux/store';
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import { JWT } from "../../../Utils/JWT";
import { logout } from "../../../Redux/State/Auth";
import BusyArea from "../../Shared/BusyArea";
import LanguageDropdown from '../../Shared/LanguageDropdown';
import IconSVG from '../../../Assets/icon.svg?component';

const LoginPage = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();

    const logoutError = useAppSelector((s) => s.auth.logoutReason);
    const [login, { isLoading }] = useLoginMutation();
    const [error, setError] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [roleError, setRoleError] = useState('');
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        const pathSegments = window.location.pathname.split('/');
        const currentLang = pathSegments[1].toLowerCase();
        const validLanguages = ['nl', 'en', 'de', 'fr', 'es'];

        if (validLanguages.includes(currentLang)) {
            i18n.changeLanguage(currentLang).then(() => {
            });
        }
    }, [i18n]);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            navigate(`/${i18n.language}/dashboard`);
        }
    }, [navigate, i18n.language]);

    const handleLogin = async ({ email, password }: { email: string, password: string }) => {
        if (busy) return;
        setSubmitted(true);
        setBusy(true);
        setRoleError('');
        setError('');
        try {
            await login({ email, password }).unwrap();

            const roles = JWT.read<Array<string>>('roles') || [];
            if (roles.includes('ROLE_USER')) {
                dispatch(logout());
                setError(t('login:accesDenied') || "");
            } else {
                navigate(`/${i18n.language}/dashboard`);
            }
        } catch (e: any) {
            let error = e.status as keyof typeof Strings.nl.login_error;
            if (!Object.keys(Strings.nl.login_error).includes(error + '')) error = 'any';
            const errorKey = (Strings.nl.login_error[error]);
            setError(t(`login:${errorKey}`) as string);
        }

        setBusy(false);
    }

    return (
        <>
            <SidePanelWrapper style={{ position: 'relative', display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '100vh', backgroundColor: 'white' }}>
                <BusyArea busy={busy}>
                    <div className='flex justify-between items-center absolute top-0 left-0 p-5 w-full'>
                        <div className='text-brand flex items-center gap-2 font-bold'><IconSVG className='w-10 h-10' /><span className='text-2xl ml-1 font-app'>D I G I P A S</span></div>
                        <LanguageDropdown />
                    </div>

                    <Title center style={{ fontSize: '40px', fontFamily: 'Inter, sans-serif', fontWeight: '400', lineHeight: '1.5' }} text={window.location.hash === '#re-login' ? t('login:relogin') : t('login:welcome')} />
                    <StatusPopups setText={setError} type='error' text={error} />
                    <StatusPopups setText={setRoleError} type='error' text={roleError} />
                    <Form submit={handleLogin} className='my-5'>
                        <Input autoComplete submitted={submitted ? true : false} type='email' label={t('login:email') as string} id='email' placeholder={t('login:email') as string} />
                        <Input submitted={submitted ? true : false} type='password' label={t('login:password')} id='password' placeholder={t('login:password') as string} />
                        <div className="flex w-full mb-4">
                            <Button title={t('login:login')} icon={isLoading ? faSpinner : faRightToBracket} className="flex-1 py-2 " />
                        </div>
                        <div className="flex mt-10">
                            <Link to={`/${i18n.language}/forgotpassword`} style={{ fontSize: '16px' }} className="w-full text-center no-underline hover:underline">
                                {t('login:forgotPassword')}
                            </Link>
                        </div>
                    </Form>
                </BusyArea>
            </SidePanelWrapper>
        </>
    )
}

export default LoginPage;
